module.exports = __webpack_public_path__ + "img/1791992919470.3d5861aa.png";